




















































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import { DropdownLight } from '../../../../shared/dropdown-light';
import { required, email } from 'vuelidate/lib/validators';

const cssPrefix = 'mx-record-dialog';

@Component({
  components: {
    ...UUIFComponent,
    DropdownLight,
  },
  validations: {
    replyTo: { required, email },
    subject: { required },
    desc: { required },
  },
})
export default class MxRecordDialog extends SwExtendedVue {
  @Prop() showMXRecordDialog: boolean;
  @Prop() domainName: string;
  @Prop() mxRecords: any;
  cssPrefix = cssPrefix;

  created() {
    this.$store.commit('stopLoading');
  }

  closeDialog() {
    this.$emit('closeDialog');
  }
}
